import React, { useState } from "react";

const JsonEscaper = () => {
  const [inputJson, setInputJson] = useState("");
  const [escapedJson, setEscapedJson] = useState("");

  // Function to escape the JSON string
  const handleEscapeJson = (jsonString) => {
    try {
      // First parse the JSON string to validate its format
      const parsedJson = JSON.parse(jsonString);
      // Then stringify the JSON back, which automatically escapes characters
      let output = JSON.stringify(JSON.stringify(parsedJson))
      setEscapedJson(output.slice(1,output.length-1));
    } catch (error) {
      // Handle invalid JSON format
      setEscapedJson("Invalid JSON format");
    }
  };

  // Handle input change
  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputJson(value);
    handleEscapeJson(value); // Update escaped JSON when input changes
  };

  return (
    <div style={{ padding: "20px", maxWidth: "600px", margin: "auto" }}>
      <h3>JSON Escaper</h3>
      <div>
        <label>Input JSON:</label>
        <textarea
          rows="6"
          cols="50"
          value={inputJson}
          onChange={handleInputChange}
          placeholder='Enter JSON (e.g., {"key": "value"})'
        />
      </div>
      <div style={{ marginTop: "20px" }}>
        <label>Escaped JSON:</label>
        <textarea
          rows="6"
          cols="50"
          value={escapedJson}
          readOnly
          placeholder='Escaped JSON will appear here'
        />
      </div>
    </div>
  );
};

export default JsonEscaper;